'use client';
import { jsx } from 'react/jsx-runtime';
import { useFileInputContext } from './file-input.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { Button } from '../button/button.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const FileInputLabel = renderWithRef('FileInputLabel', null, (o, i)=>{
    var { children: c, skin: p, size: l, width: s, specialVariant: a, iconPosition: u, buttonShape: b } = o, f = _object_without_properties(o, [
        "children",
        "skin",
        "size",
        "width",
        "specialVariant",
        "iconPosition",
        "buttonShape"
    ]);
    let { inputId: O, disabled: y } = useFileInputContext();
    return jsx(Button, {
        skin: p,
        size: l,
        width: s,
        specialVariant: a,
        iconPosition: u,
        buttonShape: b,
        render: ({ className: t })=>jsx(RenderComp, {
                root: "label",
                forwardedRef: i,
                classNames: [
                    'swan-file-input-label',
                    null != t ? t : ''
                ],
                props: _object_spread_props(_object_spread({}, f), {
                    htmlFor: O,
                    'aria-disabled': y
                }),
                children: c
            })
    });
});

export { FileInputLabel };
